import React, { Component } from 'react';
import { Intent } from '@blueprintjs/core';

import CoreSegmentedControl from 'core/components/SegmentedControl';
import EmptyState from 'core/components/EmptyState';

export default class SegmentedControl extends Component {
  handleChange = (value) => {
    const { onChange } = this.props;
    onChange(value);
  };

  render() {
    const { field, options, disabled, intent, fill, small, large, inline, ...rest } = this.props;
    const controlOptions = options || field.options;

    if (!controlOptions.length) {
      return <EmptyState description="There are no available options" />;
    }

    return (
      <CoreSegmentedControl
        options={controlOptions}
        value={field.value}
        onChange={this.handleChange}
        disabled={disabled}
        intent={intent || Intent.PRIMARY}
        fill={fill}
        small={small}
        large={large}
        inline={inline}
        {...rest}
      />
    );
  }
}
